<!-- ============================================================
     HELP DESK & TICKET MANAGEMENT
     ============================================================ -->
<div class="hd-page">

  @if (toast_msg()) {
    <div class="hd-toast alert alert-success d-flex align-items-center gap-2 shadow">
      <i class="bi bi-check-circle-fill fs-5"></i><strong>{{ toast_msg() }}</strong>
    </div>
  }

  <!-- ══ KB ARTICLE VIEW MODAL ════════════════════════════════ -->
  @if (show_kb_article()) {
    @let ka = show_kb_article()!;
    <div class="hd-overlay" (click)="show_kb_article.set(null)">
      <div class="hd-modal-lg kb-article-modal" (click)="$event.stopPropagation()">
        <div class="hdmh" [style.background]="'linear-gradient(135deg,'+get_cat_color(ka.category)+',#1a3a6b)'">
          <div class="hdmh-icon"><i class="bi {{ get_cat_icon(ka.category) }}"></i></div>
          <div><h5 class="hdmh-title">{{ ka.title }}</h5><p class="hdmh-sub">{{ ka.category }} · {{ ka.views }} views · {{ ka.helpful }} found helpful</p></div>
          <button class="hdmh-close" (click)="show_kb_article.set(null)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="hdmb p-4">
          <div class="kb-content">{{ ka.content }}</div>
        </div>
        <div class="hdmf">
          <div class="d-flex align-items-center gap-2 text-muted small"><i class="bi bi-hand-thumbs-up me-1"></i>Was this helpful?</div>
          <button class="btn btn-outline-success btn-sm" (click)="mark_kb_helpful(ka.id); show_kb_article.set(null)">
            <i class="bi bi-hand-thumbs-up-fill me-1"></i>Yes, helpful
          </button>
          <button class="btn btn-outline-secondary btn-sm ms-auto" (click)="show_kb_article.set(null)">Close</button>
        </div>
      </div>
    </div>
  }

  <!-- ══ NEW TICKET MODAL ═════════════════════════════════════ -->
  @if (show_new_ticket()) {
    <div class="hd-overlay" (click)="show_new_ticket.set(false)">
      <div class="hd-modal-lg" (click)="$event.stopPropagation()">
        <div class="hdmh">
          <div class="hdmh-icon"><i class="bi bi-ticket-fill"></i></div>
          <div><h5 class="hdmh-title">Raise a New Ticket</h5><p class="hdmh-sub">Describe your issue and we'll get back to you</p></div>
          <button class="hdmh-close" (click)="show_new_ticket.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="hdmb p-4">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label fw-semibold">Subject / Title <span class="req">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="new_form.title" maxlength="120"
                placeholder="Brief description of the issue"
                [class.is-invalid]="new_submitted && !new_form.title?.trim()">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Category <span class="req">*</span></label>
              <select class="form-select" [(ngModel)]="new_form.category">
                @for (c of ['IT Support','Admission','Finance','Library','Transport','Maintenance','HR','Academic','Other']; track c) {
                  <option [value]="c">{{ c }}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Priority</label>
              <select class="form-select" [(ngModel)]="new_form.priority">
                @for (p of ['Critical','High','Medium','Low']; track p) { <option [value]="p">{{ p }}</option> }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Assign To</label>
              <select class="form-select" [(ngModel)]="new_form.assigned_to">
                <option value="" [selected]="!new_form.assigned_to">ERP Support</option>
                @for (a of staff(); track a) { <option [value]="a.emp_code" [selected]="new_form.assigned_to==a.emp_code">{{ a.first_name }} {{ a.last_name }} ({{ dataService.getDeptName(a.department) }})</option> }
                <!-- <option value="Ashish Pawar">Ashish Pawar (IT)</option>
                <option value="Kavita Singh">Kavita Singh (Finance)</option>
                <option value="Suresh Patel">Suresh Patel (Admin)</option>
                <option value="Priya Nair">Priya Nair (Academic)</option> -->
              </select>
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Description <span class="req">*</span></label>
              <textarea class="form-control" [(ngModel)]="new_form.description" rows="4" maxlength="1000"
                placeholder="Provide full details: what happened, when, affected users/systems, any error messages…"
                [class.is-invalid]="new_submitted && !new_form.description?.trim()"></textarea>
            </div>
            <div class="col-12"><div class="new-ticket-section-hdr">Requester Information</div></div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Your Name <span class="req">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="new_form.requester_name"
                [class.is-invalid]="new_submitted && !new_form.requester_name?.trim()">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Department</label>
              <input type="text" class="form-control" [(ngModel)]="new_form.requester_dept" maxlength="80">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Email</label>
              <input type="email" class="form-control" [(ngModel)]="new_form.requester_email" maxlength="100">
            </div>
          </div>
          @if (new_submitted && (!new_form.title?.trim() || !new_form.requester_name?.trim() || !new_form.description?.trim())) {
            <div class="alert alert-danger d-flex gap-2 align-items-center mt-3 py-2">
              <i class="bi bi-exclamation-triangle-fill"></i>Please fill all required fields.
            </div>
          }
        </div>
        <div class="hdmf">
          <button class="btn btn-outline-secondary px-4" (click)="show_new_ticket.set(false)">Cancel</button>
          <button class="btn hd-btn-primary px-5" (click)="save_new_ticket()">
            <i class="bi bi-send-fill me-2"></i>Submit Ticket
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ══ TICKET DETAIL MODAL ══════════════════════════════════ -->
  @if (viewing_ticket()) {
    @let vt = viewing_ticket()!;
    <div class="hd-overlay" (click)="viewing_ticket_id.set(null)">
      <div class="hd-modal-xl ticket-detail-modal" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="ticket-modal-header pr-{{ vt.priority.toLowerCase() }}">
          <div class="tmh-left">
            <span class="tmh-no">{{ vt.ticket_no }}</span>
            <span class="{{ get_priority_class(vt.priority) }} ms-2">{{ vt.priority }}</span>
            <span class="{{ get_status_class(vt.status) }} ms-1">{{ vt.status }}</span>
            @if (is_overdue(vt)) { <span class="overdue-chip ms-1"><i class="bi bi-alarm-fill me-1"></i>OVERDUE</span> }
          </div>
          <button class="hdmh-close" (click)="viewing_ticket_id.set(null)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="tmh-title-row">
          <h5 class="ticket-modal-title">{{ vt.title }}</h5>
          <span class="tmh-cat" [style.background]="get_cat_bg(vt.category)" [style.color]="get_cat_color(vt.category)">
            <i class="bi {{ get_cat_icon(vt.category) }} me-1"></i>{{ vt.category }}
          </span>
        </div>

        <!-- Body: 2-column -->
        <div class="ticket-modal-body">

          <!-- ── Left: Description + Activity ── -->
          <div class="tmb-left">
            <div class="tmb-section">
              <div class="tmb-section-label"><i class="bi bi-card-text me-2"></i>Description</div>
              <p class="tmb-desc">{{ vt.description }}</p>
            </div>

            @if (vt.resolution_note) {
              <div class="resolution-banner">
                <i class="bi bi-check2-circle me-2"></i>
                <strong>Resolution:</strong> {{ vt.resolution_note }}
              </div>
            }

            <!-- Activity Stream -->
            <div class="tmb-section">
              <div class="tmb-section-label"><i class="bi bi-chat-left-text me-2"></i>Activity ({{ vt.comments.length }} comment{{ vt.comments.length !== 1 ? 's' : '' }})</div>
              @if (vt.comments.length === 0) {
                <div class="no-activity text-muted small">No activity yet. Be the first to comment.</div>
              }
              <div class="activity-stream" *ngIf="vt.comments && vt.comments.length">
                @for (c of vt.comments; track c.id) {
                  <div class="activity-item" [class.internal-note]="c.is_internal">
                    <div class="ai-avatar {{ c.author_role }}">{{ get_author_initials(c.author) }}</div>
                    <div class="ai-bubble">
                      <div class="ai-meta">
                        <span class="ai-author">{{ c.author }}</span>
                        <span class="ai-role {{ c.author_role }}">{{ c.author_role }}</span>
                        @if (c.is_internal) { <span class="internal-badge"><i class="bi bi-lock-fill me-1"></i>Internal</span> }
                        <span class="ai-time ms-auto">{{ fmt_datetime(c.created_at) }}</span>
                      </div>
                      <div class="ai-message">{{ c.message }}</div>
                    </div>
                  </div>
                }
              </div>

              <!-- Add comment -->
              @if (vt.status !== 'Closed') {
                <div class="add-comment-box">
                  <textarea class="form-control add-comment-ta" [(ngModel)]="new_comment_text" rows="3"
                    placeholder="Write a comment or note…"></textarea>
                  <div class="acb-footer">
                    <div class="form-check form-switch me-3">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="new_comment_internal" id="internalChk">
                      <label class="form-check-label small" for="internalChk">
                        <i class="bi bi-lock-fill me-1 text-muted"></i>Internal note (not visible to requester)
                      </label>
                    </div>
                    <button class="btn hd-btn-primary btn-sm ms-auto" (click)="add_comment()" [disabled]="!new_comment_text.trim()">
                      <i class="bi bi-send-fill me-1"></i>Post
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- ── Right: Details + Actions ── -->
          <div class="tmb-right">

            <!-- Status -->
            <div class="detail-block">
              <label class="detail-label">Status</label>
              <select class="form-select form-select-sm" [value]="vt.status"
                (change)="update_status(vt.id, $any($event.target).value)">
                @for (s of ['Open','In Progress','Pending','Resolved','Closed']; track s) {
                  <option [value]="s" [selected]="s==vt.status">{{ s }}</option>
                }
              </select>
            </div>

            <!-- Priority -->
            <div class="detail-block">
              <label class="detail-label">Priority</label>
              <select class="form-select form-select-sm" [value]="vt.priority"
                (change)="change_priority(vt.id, $any($event.target).value)">
                @for (p of ['Critical','High','Medium','Low']; track p) {
                  <option [value]="p" [selected]="p==vt.priority">{{ p }}</option>
                }
              </select>
            </div>

            <!-- Assigned To -->
            <div class="detail-block">
              <label class="detail-label">Assigned To</label>
              <select class="form-select form-select-sm" [value]="vt.assigned_to"
                (change)="assign_ticket(vt.id, $any($event.target).value)">
                <option value="" [selected]="!vt.assigned_to">ERP Support</option>
                @for (a of staff(); track a) { <option [value]="a.emp_code" [selected]="vt.assigned_to==a.emp_code">{{ a.first_name }} {{ a.last_name }} ({{ dataService.getDeptName(a.department) }})</option> }
                <!-- <option value="Ashish Pawar">Ashish Pawar</option>
                <option value="Kavita Singh">Kavita Singh</option>
                <option value="Suresh Patel">Suresh Patel</option>
                <option value="Priya Nair">Priya Nair</option>
                <option value="Anita Sharma">Anita Sharma</option> -->
              </select>
            </div>

            <!-- Requester -->
            <div class="detail-block">
              <label class="detail-label">Requester</label>
              <div class="detail-val fw-semibold">{{ vt.requester_name }}</div>
              <div class="detail-sub">{{ vt.requester_dept }}</div>
              @if (vt.requester_email) {
                <a [href]="'mailto:'+vt.requester_email" class="detail-sub text-primary">{{ vt.requester_email }}</a>
              }
            </div>

            <!-- Dates -->
            <div class="detail-block">
              <label class="detail-label">Timeline</label>
              <div class="timeline-row"><i class="bi bi-calendar-plus text-muted me-2"></i><span class="detail-sub">Created: {{ fmt_datetime(vt.created_at) }}</span></div>
              <div class="timeline-row"><i class="bi bi-clock text-muted me-2"></i>
                <span class="detail-sub {{ is_overdue(vt) ? 'text-danger fw-semibold' : '' }}">
                  Due: {{ fmt_datetime(vt.due_date) }}
                  @if (is_overdue(vt)) { <span class="ms-1 text-danger">(Overdue)</span> }
                </span>
              </div>
              @if (vt.resolved_at) {
                <div class="timeline-row"><i class="bi bi-check2-all text-success me-2"></i><span class="detail-sub text-success">Resolved: {{ fmt_datetime(vt.resolved_at) }}</span></div>
              }
              <div class="timeline-row"><i class="bi bi-arrow-clockwise text-muted me-2"></i><span class="detail-sub">Updated: {{ hours_elapsed(vt.updated_at) }}</span></div>
            </div>

            <!-- SLA -->
            <div class="detail-block">
              <label class="detail-label">SLA Target</label>
              <div class="sla-pill {{ is_overdue(vt) ? 'sla-breached' : 'sla-ok' }}">
                <i class="bi {{ is_overdue(vt) ? 'bi-exclamation-triangle-fill' : 'bi-shield-check-fill' }} me-1"></i>
                {{ vt.sla_hours }}h response · {{ is_overdue(vt) ? 'SLA Breached' : 'Within SLA' }}
              </div>
            </div>

            <!-- Resolve Section -->
            @if (vt.status !== 'Resolved' && vt.status !== 'Closed') {
              <div class="resolve-block">
                <label class="detail-label">Resolution Note</label>
                <textarea class="form-control form-control-sm" [(ngModel)]="resolve_note" rows="3"
                  placeholder="Describe how the issue was resolved…"></textarea>
                <button class="btn btn-success w-100 mt-2" (click)="resolve_ticket(vt.id)"
                  [disabled]="!resolve_note.trim()">
                  <i class="bi bi-check2-all me-2"></i>Mark as Resolved
                </button>
              </div>
            }
            @if (vt.status === 'Resolved') {
              <button class="btn btn-outline-secondary w-100 mt-2" (click)="close_ticket(vt.id)">
                <i class="bi bi-archive-fill me-2"></i>Close Ticket
              </button>
              <button class="btn btn-outline-warning w-100 mt-2" (click)="reopen_ticket(vt.id)">
                <i class="bi bi-arrow-counterclockwise me-2"></i>Reopen
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ════════════ PAGE HEADER ════════════════════════════════ -->
  <div class="hd-ph mb-4">
    <div class="d-flex align-items-center gap-3">
      <div class="hd-logo"><i class="bi bi-headset"></i></div>
      <div>
        <h1 class="hd-title">Help Desk</h1>
        <p class="hd-subtitle">Ticket management · Support · Knowledge base</p>
      </div>
    </div>
    <button class="btn hd-btn-primary" (click)="open_new_ticket()">
      <i class="bi bi-plus-circle-fill me-1"></i>Raise Ticket
    </button>
  </div>

  <!-- TABS -->
  <div class="hd-tabs mb-4" *ngIf="user.user_role[0].code == 'spr'">
    @for (t of [{k:'dashboard',l:'Dashboard',ic:'bi-grid-fill'},{k:'tickets',l:'All Tickets',ic:'bi-ticket-fill'},{k:'kb',l:'Knowledge Base',ic:'bi-book-fill'}]; track t.k) {
      <button class="hdtab" [class.active]="active_tab() === t.k" (click)="active_tab.set($any(t.k))">
        <i class="bi {{ t.ic }} me-1"></i>{{ t.l }}
        @if (t.k === 'tickets' && ticket_stats().open > 0) {
          <span class="hdtab-badge">{{ ticket_stats().open }}</span>
        }
      </button>
    }
  </div>

  <!-- ════════════ DASHBOARD ══════════════════════════════════ -->
  @if (active_tab() === 'dashboard') {
    <!-- KPI row -->
    <div class="hd-kpi-row mb-4">
      <div class="kpi-card kpi-open" (click)="active_tab.set('tickets'); tkt_status_f.set('Open')">
        <div class="kpi-ic"><i class="bi bi-folder2-open"></i></div>
        <div><div class="kpi-val">{{ ticket_stats().open }}</div><div class="kpi-lbl">Open</div></div>
      </div>
      <div class="kpi-card kpi-inprog" (click)="active_tab.set('tickets'); tkt_status_f.set('In Progress')">
        <div class="kpi-ic"><i class="bi bi-arrow-repeat"></i></div>
        <div><div class="kpi-val">{{ ticket_stats().in_progress }}</div><div class="kpi-lbl">In Progress</div></div>
      </div>
      <div class="kpi-card kpi-pending" (click)="active_tab.set('tickets'); tkt_status_f.set('Pending')">
        <div class="kpi-ic"><i class="bi bi-hourglass-split"></i></div>
        <div><div class="kpi-val">{{ ticket_stats().pending }}</div><div class="kpi-lbl">Pending</div></div>
      </div>
      <div class="kpi-card kpi-resolved">
        <div class="kpi-ic"><i class="bi bi-check2-all"></i></div>
        <div><div class="kpi-val">{{ ticket_stats().resolved_today }} / {{ticket_stats().resolved}}</div>
        <div class="kpi-lbl">Resolved Today</div></div>
      </div>
      <div class="kpi-card kpi-overdue" [class.kpi-alert]="ticket_stats().overdue > 0" (click)="active_tab.set('tickets'); tkt_priority_f.set('Critical')">
        <div class="kpi-ic"><i class="bi bi-alarm-fill"></i></div>
        <div><div class="kpi-val {{ ticket_stats().overdue > 0 ? 'text-danger' : '' }}">{{ ticket_stats().overdue }}</div><div class="kpi-lbl">Overdue</div></div>
      </div>
    </div>

    <div class="row g-4 mb-4">
      <!-- Priority breakdown -->
      <div class="col-lg-4">
        <div class="hd-card h-100">
          <div class="hcard-hdr"><i class="bi bi-pie-chart-fill me-2"></i>Active Tickets by Priority</div>
          <div class="hcard-body d-flex align-items-center justify-content-center gap-4 flex-wrap">
            <svg viewBox="0 0 160 160" style="width:155px;height:155px;flex-shrink:0;">
              <circle cx="80" cy="80" r="52" fill="none" stroke="#f3f4f6" stroke-width="22"/>
              @for (seg of donut_segs(); track seg.label) {
                <circle cx="80" cy="80" r="52" fill="none"
                  [attr.stroke]="seg.color" stroke-width="22"
                  [attr.stroke-dasharray]="seg.dash"
                  [attr.stroke-dashoffset]="seg.offset"
                  style="transform:rotate(-90deg);transform-origin:50% 50%;"/>
              }
              @let active_count = ticket_stats().open + ticket_stats().in_progress + ticket_stats().pending;
              <text x="80" y="74" text-anchor="middle" class="svg-center-val">{{ active_count }}</text>
              <text x="80" y="92" text-anchor="middle" class="svg-center-lbl">Active</text>
            </svg>
            <div class="priority-legend">
              @for (p of priority_breakdown(); track p.label) {
                <div class="pl-item" (click)="active_tab.set('tickets'); tkt_priority_f.set($any(p.label))">
                  <div class="pl-dot" [style.background]="p.color"></div>
                  <span class="pl-lbl">{{ p.label }}</span>
                  <span class="pl-count fw-bold ms-auto" [style.color]="p.color">{{ p.count }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Category breakdown -->
      <div class="col-lg-4">
        <div class="hd-card h-100">
          <div class="hcard-hdr"><i class="bi bi-bar-chart-fill me-2"></i>Tickets by Category</div>
          <div class="hcard-body">
            @for (c of category_breakdown(); track c.cat) {
              <div class="cat-bar-row mb-2 pointer" (click)="active_tab.set('tickets'); tkt_category_f.set($any(c.cat))">
                <div class="cbr-label">
                  <i class="bi {{ get_cat_icon(c.cat) }} me-1" [style.color]="get_cat_color(c.cat)"></i>
                  <span class="small">{{ c.cat }}</span>
                </div>
                <div class="cbr-bar-wrap">
                  <div class="cbr-bar" [style.width]="c.pct+'%'" [style.background]="get_cat_color(c.cat)"></div>
                </div>
                <span class="cbr-count fw-bold small" [style.color]="get_cat_color(c.cat)">{{ c.count }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- SLA + agent panel -->
      <div class="col-lg-4 d-flex flex-column gap-3">
        <!-- SLA compliance -->
        <div class="hd-card">
          <div class="hcard-hdr"><i class="bi bi-shield-fill-check me-2"></i>SLA Compliance</div>
          <div class="hcard-body text-center py-4">
            <div class="sla-gauge">
              <div class="sla-value {{ sla_compliance() >= 80 ? 'text-success' : sla_compliance() >= 50 ? 'text-warning' : 'text-danger' }}">
                {{ sla_compliance() }}%
              </div>
              <div class="sla-label text-muted small">tickets within SLA</div>
            </div>
            <div class="progress mt-3" style="height:12px;border-radius:6px;">
              <div class="progress-bar {{ sla_compliance() >= 80 ? 'bg-success' : sla_compliance() >= 50 ? 'bg-warning' : 'bg-danger' }}" [style.width]="sla_compliance()+'%'"></div>
            </div>
            <div class="mt-2 d-flex justify-content-between small text-muted">
              <span>{{ ticket_stats().overdue }} overdue</span>
              <span>{{ ticket_stats().open + ticket_stats().in_progress + ticket_stats().pending - ticket_stats().overdue }} within SLA</span>
            </div>
          </div>
        </div>
        <!-- Quick stats -->
        <div class="hd-card flex-grow-1">
          <div class="hcard-hdr"><i class="bi bi-graph-up me-2"></i>All-time Summary</div>
          <div class="hcard-body">
            @for (s of [{l:'Total Tickets',v:ticket_stats().total,ic:'bi-collection-fill',c:'#1a3a6b'},{l:'Resolved',v:ticket_stats().resolved,ic:'bi-check-circle-fill',c:'#059669'},{l:'Closed',v:ticket_stats().closed,ic:'bi-archive-fill',c:'#6b7280'},{l:'KB Articles',v:kb_articles().length,ic:'bi-book-fill',c:'#7c3aed'}]; track s.l) {
              <div class="summary-row">
                <div class="sr-icon" [style.background]="s.c+'22'" [style.color]="s.c"><i class="bi {{ s.ic }}"></i></div>
                <span class="small text-muted">{{ s.l }}</span>
                <span class="fw-bold ms-auto" [style.color]="s.c">{{ s.v }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Overdue alert + recent tickets -->
    <div class="row g-4">
      <div class="col-lg-6">
        <div class="hd-card h-100">
          <div class="hcard-hdr overdue-hdr"><i class="bi bi-alarm-fill me-2"></i>Overdue Tickets ({{ overdue_tickets().length }})</div>
          <div class="hcard-body p-0">
            @if (overdue_tickets().length === 0) {
              <div class="p-4 text-center text-muted small"><i class="bi bi-check2-circle me-2 text-success"></i>No overdue tickets — great work!</div>
            }
            @for (t of overdue_tickets(); track t.id) {
              <div class="overdue-row" (click)="open_ticket(t)">
                <span class="{{ get_priority_class(t.priority) }}">{{ t.priority }}</span>
                <div class="or-info">
                  <div class="or-title">{{ t.title }}</div>
                  <div class="or-meta">{{ t.ticket_no }} · {{ t.category }}</div>
                </div>
                <div class="or-right">
                  <span class="{{ get_status_class(t.status) }}">{{ t.status }}</span>
                  <div class="or-due text-danger small">Due {{ fmt_date(t.due_date) }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="hd-card h-100">
          <div class="hcard-hdr"><i class="bi bi-clock-history me-2"></i>Recent Activity</div>
          <div class="hcard-body p-0">
            @for (t of recent_tickets().slice(0,6); track t.id) {
              <div class="recent-row" (click)="open_ticket(t)">
                <div class="rr-cat" [style.background]="get_cat_bg(t.category)" [style.color]="get_cat_color(t.category)">
                  <i class="bi {{ get_cat_icon(t.category) }}"></i>
                </div>
                <div class="rr-info">
                  <div class="rr-title">{{ t.title }}</div>
                  <div class="rr-meta">{{ t.ticket_no }} · {{ t.requester_name }}</div>
                </div>
                <div class="rr-right">
                  <span class="{{ get_priority_class(t.priority) }}">{{ t.priority }}</span>
                  <div class="rr-time text-muted">{{ hours_elapsed(t.updated_at) }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ════════════ ALL TICKETS ════════════════════════════════ -->
  @if (active_tab() === 'tickets') {

    <!-- Filter bar -->
    <div class="hd-card mb-3"><div class="hcard-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-4">
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" placeholder="Ticket no., title, requester, category…"
              [value]="tkt_search()" (input)="tkt_search.set($any($event.target).value)">
            @if (tkt_search()) { <button class="btn btn-outline-secondary" (click)="tkt_search.set('')"><i class="bi bi-x"></i></button> }
          </div>
        </div>
        <div class="col-md-2">
          <select class="form-select" [value]="tkt_status_f()" (change)="tkt_status_f.set($any($event.target).value)">
            <option value="">All Status</option>
            @for (s of ['Open','In Progress','Pending','Resolved','Closed']; track s) { <option [value]="s">{{ s }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select" [value]="tkt_priority_f()" (change)="tkt_priority_f.set($any($event.target).value)">
            <option value="">All Priority</option>
            @for (p of ['Critical','High','Medium','Low']; track p) { <option [value]="p">{{ p }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select" [value]="tkt_category_f()" (change)="tkt_category_f.set($any($event.target).value)">
            <option value="">All Categories</option>
            @for (c of unique_categories(); track c) { <option [value]="c">{{ c }}</option> }
          </select>
        </div>
        <div class="col-md-1">
          <select class="form-select" [value]="tkt_agent_f()" (change)="tkt_agent_f.set($any($event.target).value)">
            <option value="">All Agents</option>
            @for (a of unique_agents(); track a) { <option [value]="a">{{ a }}</option> }
          </select>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-secondary" (click)="reset_filters()"><i class="bi bi-arrow-counterclockwise"></i></button>
        </div>
      </div>
      <small class="text-muted mt-2 d-block">{{ filtered_tickets()?.length }} ticket(s) · sorted by priority</small>
    </div></div>

    @if (filtered_tickets()?.length === 0) {
      <div class="empty-state"><i class="bi bi-ticket-detailed"></i><p>No tickets match the current filters.</p></div>
    } @else {
      <div class="ticket-list">
        @for (t of filtered_tickets(); track t.id) {
          <div class="ticket-row pr-border-{{ t.priority.toLowerCase() }}" [class.tr-overdue]="is_overdue(t)" (click)="open_ticket(t)">
            <!-- Priority dot -->
            <div class="tr-priority-dot {{ get_priority_class(t.priority) + '-dot' }}"></div>
            <!-- Cat icon -->
            <div class="tr-cat-icon" [style.background]="get_cat_bg(t.category)" [style.color]="get_cat_color(t.category)">
              <i class="bi {{ get_cat_icon(t.category) }}"></i>
            </div>
            <!-- Main info -->
            <div class="tr-main">
              <div class="tr-row1">
                <span class="tr-no font-mono">{{ t.ticket_no }}</span>
                <span class="{{ get_priority_class(t.priority) }} ms-1">{{ t.priority }}</span>
                <span class="{{ get_status_class(t.status) }} ms-1">{{ t.status }}</span>
                @if (is_overdue(t)) { <span class="overdue-chip"><i class="bi bi-alarm-fill me-1"></i>OVERDUE</span> }
                <span class="tr-cat-chip ms-1" [style.background]="get_cat_bg(t.category)" [style.color]="get_cat_color(t.category)">{{ t.category }}</span>
              </div>
              <div class="tr-title">{{ t.title }}</div>
              <div class="tr-meta">
                <span><i class="bi bi-person me-1"></i>{{ t.requester_name }} · {{ t.requester_dept }}</span>
                @if (t.assigned_to) { <span class="ms-2"><i class="bi bi-person-check me-1"></i>{{ t.assigned_to }}</span> }
                <span class="ms-2"><i class="bi bi-chat-dots me-1"></i>{{ t.comments.length }}</span>
              </div>
            </div>
            <!-- Right: dates & SLA -->
            <div class="tr-right">
              <div class="tr-date small text-muted">{{ hours_elapsed(t.created_at) }}</div>
              <div class="tr-due small {{ is_overdue(t) ? 'text-danger fw-semibold' : 'text-muted' }}">
                Due: {{ fmt_date(t.due_date) }}
              </div>
              <div class="tr-sla">
                <i class="bi {{ is_overdue(t) ? 'bi-exclamation-triangle-fill text-danger' : 'bi-shield-check text-success' }}"></i>
              </div>
            </div>
          </div>
        }
      </div>
    }
  }

  <!-- ════════════ KNOWLEDGE BASE ═════════════════════════════ -->
  @if (active_tab() === 'kb') {

    <!-- KB Header -->
    <div class="kb-header-section mb-4">
      <h2 class="kb-hero-title"><i class="bi bi-book-fill me-2 text-primary"></i>Knowledge Base</h2>
      <p class="kb-hero-sub">Find answers to common questions before raising a ticket</p>
      <div class="kb-search-wrap">
        <div class="input-group kb-search-input">
          <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
          <input class="form-control border-start-0" placeholder="Search articles…"
            [value]="kb_search()" (input)="kb_search.set($any($event.target).value)">
          @if (kb_search()) { <button class="btn btn-outline-secondary" (click)="kb_search.set('')"><i class="bi bi-x"></i></button> }
        </div>
      </div>
    </div>

    <!-- Category filter -->
    <div class="kb-cat-filters mb-4">
      <button class="kb-cat-btn {{ !kb_cat_f() ? 'active' : '' }}" (click)="kb_cat_f.set('')">
        <i class="bi bi-grid-fill me-1"></i>All ({{ kb_articles().length }})
      </button>
      @for (cat of kb_categories(); track cat) {
        <button class="kb-cat-btn {{ kb_cat_f() === cat ? 'active' : '' }}" (click)="kb_cat_f.set(cat)">
          <i class="bi {{ get_cat_icon($any(cat)) }} me-1" [style.color]="get_cat_color(cat)"></i>{{ cat }}
        </button>
      }
    </div>

    @if (filtered_kb().length === 0) {
      <div class="empty-state"><i class="bi bi-search"></i><p>No articles match your search.</p>
        <button class="btn hd-btn-primary btn-sm" (click)="open_new_ticket()"><i class="bi bi-ticket-fill me-1"></i>Raise a Ticket Instead</button>
      </div>
    } @else {
      <div class="kb-grid">
        @for (a of filtered_kb(); track a.id) {
          <div class="kb-card" (click)="open_kb_article(a)">
            <div class="kbc-header">
              <div class="kbc-cat-icon" [style.background]="get_cat_bg(a.category)" [style.color]="get_cat_color(a.category)">
                <i class="bi {{ get_cat_icon(a.category) }}"></i>
              </div>
              <div class="kbc-cat-label" [style.color]="get_cat_color(a.category)">{{ a.category }}</div>
            </div>
            <div class="kbc-title">{{ a.title }}</div>
            <div class="kbc-summary">{{ a.summary }}</div>
            <div class="kbc-footer">
              <span class="kbc-views"><i class="bi bi-eye me-1"></i>{{ a.views }}</span>
              <span class="kbc-helpful ms-3"><i class="bi bi-hand-thumbs-up me-1"></i>{{ a.helpful }}</span>
              <span class="kbc-read ms-auto">Read article <i class="bi bi-arrow-right-short"></i></span>
            </div>
          </div>
        }
      </div>
      <div class="kb-cta mt-4">
        <i class="bi bi-question-circle me-2"></i>Didn't find what you were looking for?
        <button class="btn hd-btn-primary btn-sm ms-2" (click)="open_new_ticket()">
          <i class="bi bi-ticket-fill me-1"></i>Raise a Support Ticket
        </button>
      </div>
    }
  }

</div>
